"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollEvent = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useNumberState_1 = require("./useNumberState");
var useContentHeight_1 = require("./useContentHeight");
function useScrollEvent(content, size, onScroll) {
    var _a = tslib_1.__read(useNumberState_1.useNumberState(), 2), top = _a[0], setTop = _a[1];
    var _b = tslib_1.__read(useNumberState_1.useNumberState(), 2), bottom = _b[0], setBottom = _b[1];
    var contentHeight = useContentHeight_1.useContentHeight(content);
    react_1.useEffect(function () {
        calculateOpacities(content, size, [top, setTop], [bottom, setBottom]);
    }, [bottom, setBottom, setTop, size, top, content, contentHeight]);
    var onScrollHandler = react_1.useCallback(function (event) {
        calculateOpacities(content, size, [top, setTop], [bottom, setBottom]);
        onScroll === null || onScroll === void 0 ? void 0 : onScroll(event);
    }, [bottom, onScroll, setBottom, setTop, size, top, content]);
    return { top: top, bottom: bottom, onScrollHandler: onScrollHandler };
}
exports.useScrollEvent = useScrollEvent;
function calculateOpacities(content, size, t, b) {
    var scrollTop = content ? content.scrollTop : 0;
    var topOpacity = calculateOpacity(scrollTop, size);
    var scrollBottom = content ? content.scrollHeight - content.offsetHeight - content.scrollTop : 0;
    var bottomOpacity = calculateOpacity(scrollBottom, size);
    var _a = tslib_1.__read(t, 2), top = _a[0], setTop = _a[1];
    if (top !== topOpacity) {
        setTop(topOpacity);
    }
    var _b = tslib_1.__read(b, 2), bottom = _b[0], setBottom = _b[1];
    if (bottom !== bottomOpacity) {
        setBottom(bottomOpacity);
    }
}
function calculateOpacity(current, size) {
    var opacity = Math.min(current / size, 1);
    if (opacity > 0) {
        return Math.max(opacity, 0.2);
    }
    return opacity;
}
//# sourceMappingURL=useScrollEvent.js.map